import React, { useState } from 'react';
import { createTheme } from '@mui/material';
import { ThemeProvider } from '@material-ui/styles';
import { Grid, FormControl, TextField, InputAdornment } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import { setPasswordAccount } from '../../actions/accountAction';

const theme = createTheme({
  overrides: {
    MuiTextField: {
      root: {
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            backgroundColor: 'white',
            borderColor: '#CAD8FF',
            zIndex: -1
          },
          borderRadius: '10px',
          fontFamily: 'Poppins',
          fontSize: '14px',
          height: '40px',
          zIndex: 1
        },
        '& .password-grid': {
          backgroundColor: '#EFF0F6',
          borderRadius: '8px !important',
          boxSizing: 'border-box',
          height: '56px',
          width: '384px !important'
        }
      }
    }
  }
});

const formStyle = {
  marginBottom: '48px',
  marginTop: '96px',
  width: '384px'
};

const error1 = {
  color: '#4E4B66',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '18px',
  padding: '0 16px',
  textAlign: 'left'
};

const error2 = {
  color: 'red',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '18px',
  padding: '0 16px',
  textAlign: 'left'
};

const error3 = {
  color: 'red',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '18px',
  padding: '0 16px',
  textAlign: 'left'
};

const Security = ({ submit, passMatch, passShort, error }) => {
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();
  const passwordDraft = useSelector(({ account }) => account.passwordDraft);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const onInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(
      setPasswordAccount({
        ...passwordDraft,
        [name]: value
      })
    );
  };

  return (
    <FormControl>
      <form
        autoComplete="off"
        className="password-form"
        id="password-form"
        noValidate
        style={formStyle}
      >
        <ThemeProvider theme={theme}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                autoComplete="off"
                fullWidth
                id="outlined-adornment-password1"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        edge="end"
                        onClick={handleClickShowPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                name="oldPassword"
                onChange={onInputChange}
                placeholder="Old Password"
                type={showPassword ? 'text' : 'password'}
                value={passwordDraft.oldPassword || ''}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                autoComplete="off"
                fullWidth
                id="outlined-adornment-password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        edge="end"
                        onClick={handleClickShowPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                name="newPassword"
                onChange={onInputChange}
                placeholder="New Password"
                type={showPassword ? 'text' : 'password'}
                value={passwordDraft.newPassword || ''}
                variant="outlined"
              />
            </Grid>

            <p style={error1}>Use 8 or more characters with a mix of letters, numbers & symbols</p>

            <p
              style={{
                ...error2,
                display: submit && passMatch ? 'block' : 'none'
              }}
            >
              Passwords match
            </p>

            <p
              style={{
                ...error3,
                display: submit && passShort ? 'block' : 'none'
              }}
            >
              Password should be 8 symbols or more
            </p>
          </Grid>

          <div
            style={{
              color: 'red',
              display: error && submit ? 'block' : 'none'
            }}
          >
            Please fill in the required fields
          </div>
        </ThemeProvider>
      </form>
    </FormControl>
  );
};

export default Security;
